// Apply correction deltas to original invoice line items by ordinal.

import { applyDeltas } from '../../calc.ts';
import type { DisplayPricing } from '../../types.ts';
import type { InvoiceLineRow } from '../../types/invoice.ts';

/** DisplayPricing with ordinal. */
export type EffectiveLineItem = DisplayPricing & { ordinal: number };

/** Apply correction deltas to originals, matched by ordinal. */
export function applyCorrections(
  originals: InvoiceLineRow[],
  corrections: InvoiceLineRow[],
): EffectiveLineItem[] {
  return originals.map(li => {
    const deltas = corrections.filter(c => c.ordinal === li.ordinal);
    return { ordinal: li.ordinal, ...applyDeltas(li, deltas) };
  });
}
